import React from "react"
import { FaInfoCircle } from "react-icons/fa"

const CautionNote = () => (
  <div className="bg-yellow-500 rounded py-4 px-6 shadow text-red-900">
    <h1 className="text-red-900 flex items-center text-2xl mb-2">
      <span className="mr-2">
        <FaInfoCircle />
      </span>
      <span>Note</span>
    </h1>
    <p className="">
      This tool is as a decision support tool designed to be used by pregnant
      women and their health care providers. It should not replace clinical
      judgement.
    </p>
  </div>
)

export default CautionNote
